"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const style_overider_1 = __importDefault(require("utils/style-overider"));
const button_style_1 = __importDefault(require("../button.style"));
const ButtonIcon = (_a) => {
    var { src } = _a, props = __rest(_a, ["src"]);
    return ((0, jsx_runtime_1.jsx)("img", Object.assign({ alt: '' }, props, { src: src, style: (0, style_overider_1.default)(button_style_1.default.iconStyle, props.style) })));
};
exports.default = ButtonIcon;
